<button type="button" class="btn btn--ghost btn--default" (click)="openModal(template)">{{buttonText}}</button>
<ng-template #template>
    <div id="confirm-window-template" class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title" id="modalDeleteLabel">{{ titleMessage }}</h1>
        </div>
        <div class="modal-body">
            <p [innerHTML]="bodyMessage"></p>
            <div class="btn-group">
                <button #cancelButton type="submit" class="btn btn--plain btn--primary" (click)="decline()">
                    {{ declineTextMessage }}
                </button>
                <button type="button" class="btn btn--ghost btn--default" (click)="confirm()" data-dismiss="modal">
                    {{ confirmTextMessage }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
